// learnReducer.js
const initialState = {
  selectedItem: null, // اینجا آیتم انتخابی ذخیره میشه
  openAfterVideo: null,
};

export default function learnReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SELECTED_LEARN_ITEM':
      return {
        ...state,
        selectedItem: action.payload,
      };
    case 'CLEAR_SELECTED_LEARN_ITEM':
      return {
        ...state,
        selectedItem: null,
      };
    case 'SET_OPEN_AFTER_VIDEO':
      return {
        ...state,
        openAfterVideo: action.payload,
      };
    default:
      return state;
  }
}
